export const EstateSelectorFallback = (): JSX.Element => {
  return (
    <div className="w-[5.625rem] h-[5.625rem] justify-self-center select-none lg:h-[5.8125rem]">
      <div className="bg-grey50 p-3 rounded-md w-[5.625rem] h-[5.625rem] animate-pulse"></div>
    </div>
  );
};
